import routes from '@Constants/Routes'
import { generatePath } from 'react-router'
import { useLocation } from 'react-router-dom'

export type CourseParentType = 'classroom' | 'standalone'

/**
 * The unit player is mounted under two parents: /classroom/:label/course/:cId
 * (legacy) and /courses/:label/lecture/:cId (standalone). Both carry the same
 * :label/:cId params, so shared navigation code detects the parent from the
 * current URL instead of threading context everywhere.
 */
export const parentTypeFromPathname = (pathname: string): CourseParentType =>
	pathname.startsWith(routes.courses + '/') ? 'standalone' : 'classroom'

export const useCourseParentType = (): CourseParentType => {
	const { pathname } = useLocation()
	return parentTypeFromPathname(pathname)
}

/** Path of the parent page (classroom overview / standalone course details). */
export const courseParentPath = (parentType: CourseParentType, label: string) =>
	generatePath(parentType === 'standalone' ? routes.standaloneCourse : routes.classroom, { label })

/** Path of the unit-player shell for a course/lecture. */
export const coursePlayerPath = (parentType: CourseParentType, label: string, cId: string | number) =>
	parentType === 'standalone'
		? generatePath(routes.standaloneLecture, { label, cId: cId.toString() })
		: generatePath(`${routes.classroom}/${routes.course}`, { label, cId: cId.toString() })
